import axios from "axios";

const RESOURCE_NAME = "/settings";

export default {
  offices() {
    return axios.get(RESOURCE_NAME);
  },
  update(office) {
    return axios.put(RESOURCE_NAME+"/"+office.id, office);
  },
  set(office_id) {
    return axios.post("/office-set/", { selection: office_id });
  },
  paimentMeans() {
    return axios.get("/paiment-mean");
  },
  updatePaimentMeans(paimentMeans) {
    return new Promise(function(resolve, reject) {
      paimentMeans.forEach(p => {
        axios.put("/paiment-mean/"+p.id, p).catch(err => reject(err));
      });
      resolve();
    });
  },
  getHelpOnInvoiceContent() {
    return axios.get("web-view/enterprise/help-on-invoice-content", {baseURL: '/'});
  },
  officeUsers() {
    return axios.get('/office-users');
  },
  updateOfficeUsers(user) {
    if (user.id) {
      return axios.put('/office-users/'+user.id, user);
    }
  },
  addUser(user) {
    return axios.post('/office-users', user);
  }
};
